import React, { useState, useEffect } from 'react';

const QuickCount = ({ limit = 3000 }) => {
    const [count, setCount] = useState(0);
    const [running, setRunning] = useState(true);

    const incrementCount = () => {
        setCount((prevCount) => {
        if (prevCount >= limit) {
            setRunning(false); // Stop when the limit is reached
            return limit;
        }
        return prevCount + 1;
        });
        if (running) {
        requestAnimationFrame(incrementCount); // Continue the loop
        }
    };

  useEffect(() => {
    if (running) {
      requestAnimationFrame(incrementCount); // Start the animation
    }

    return () => setRunning(false); // Clean up when the component is unmounted
  }, [running]);

  return (
    <div style={{ fontSize: '48px', textAlign: 'center' }}>
      {count}
    </div>
  );
};

export default QuickCount;
